export const countryMobileLengths = {
  "India": 10,
  "Australia": 9,
  "Bolivia": 8,
  // Add other countries as needed, or libphonenumber-js will handle them
};
